export const CUSTOMERWORKOUTPLANS_RECEIVED = "CUSTOMERWORKOUTPLANS_RECEIVED";
export const SET_CUSTOMERWORKOUTPLAN = "SET_CUSTOMERWORKOUTPLAN";
export const CREATE_CUSTOMERWORKOUTPLAN = "CREATE_CUSTOMERWORKOUTPLAN";
export const SET_PROPERTY_CUSTOMERWORKOUTPLAN =
  "SET_PROPERTY_CUSTOMERWORKOUTPLAN";
